import api from '../api/'

import * as types from './mutation-types'
import { scanner } from '../js/Scanner.js'

export const getScannerParams = ({ commit, dispatch, state }) => {
    return api.scannerParams()
        .then(res => {
            commit(types.SET_SCANNER_PARAMS, res);
        })
        .catch(res => {
            throw 'failed to get scanner params';
        })
}

export const setFiltersFromUrl = ({ commit }, queryParams) => {
    const urlFilters = scanner.filters;

    //--spLow and spHigh replace @/+
    queryParams.spRatingAbove = queryParams.spRatingAbove?.replace('@', '+');
    queryParams.spRatingBelow = queryParams.spRatingBelow?.replace('@', '+');

    const filters = [];
    for (let query in queryParams) {
        if (['loginType', 'action'].includes(query)) { continue; }

        if (['locations', 'instrument', 'scanCode', 'secType','page'].includes(query)) {
            urlFilters[query] = queryParams[query];
        } else {
            if (query === 'industryLike') {
                queryParams[query] = queryParams[query].replace(/_/g, '#');
            }
            filters.push({
                code: query,
                value: queryParams[query] || ''
            });
        }
    }
    urlFilters.filters = filters;
    commit('SET_FILTERS_FROM_URL', urlFilters);
}

export const resetFiltersFromUrl = ({ commit }) => {
    commit('SET_FILTERS_FROM_URL', {});
}

export const setBondFieldsFromUrl = ({ state, commit }, { queryParams, states, countries }) => {
    //spLow and spHigh replace @/+
    queryParams.spRatingAbove = queryParams.spRatingAbove?.replace('@', '+');
    queryParams.spRatingBelow = queryParams.spRatingBelow?.replace('@', '+');

    let stateLabel = "All";
    if (queryParams.bondUSStateLike) {
        const curState = states.find(state => state.value === queryParams.bondUSStateLike);
        stateLabel = curState && curState.label;
    }

    let issuerLabel = "All";
    if (queryParams.issuerCountryIs) {
        const country = (countries || []).find(c => c.value === queryParams.issuerCountryIs);
        issuerLabel = country && country.label;
    }

    let industriesLabel = "All"
    if (queryParams.industryLike) {
        industriesLabel = queryParams.industryLike.replace(/#/g, ',');
    }

    const bondFields = {
        couponMax: queryParams.couponRateBelow || "",
        couponMin: queryParams.couponRateAbove || "",
        currencyLabel: queryParams.currencyLike || "All",
        endDate: queryParams.maturityDateBelow || "",
        industryLabel: industriesLabel,
        issuerLabel: issuerLabel,
        moodyHigh: queryParams.moodyRatingBelow || "",
        moodyLow: queryParams.moodyRatingAbove || "",
        spHigh: queryParams.spRatingBelow || "",
        spLow: queryParams.spRatingAbove || "",
        startDate: queryParams.maturityDateAbove ||"",
        stateLabel: stateLabel,
        treasuryType: queryParams.bondAssetSubTypeStrBeginsWithOneOf || "",
        yieldMax: queryParams.bondAskYieldBelow || "",
        yieldMin: queryParams.bondAskYieldAbove || ""
    }
    commit('SET_BOND_FIELDS_FROM_URL', bondFields);
}

export const resetBondFieldsFromUrl = ({ commit }) => {
    commit('SET_BOND_FIELDS_FROM_URL', {});
}
